// Bare section labels like "EXCLUDES:", "Exclusions", "NOT INCLUDED:" are proposal
// headers, not exclusion items. Filter them out of display/email output.
const BARE_LABEL_RE = /^\s*(?:scope\s+|proposal\s+)?(?:specific\s+)?(?:excludes?|excluded|exclusions?|nic|not\s+included)\s*[:\-–—]?\s*$/i;

export const isBareExclusionLabel = (s) => BARE_LABEL_RE.test((s || '').trim());

export const cleanExclusionItems = (items) =>
  (items || []).filter((x) => typeof x === 'string' && !isBareExclusionLabel(x));
